/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1Ssoimage200,
  GetApiV1Ssoimage400,
  GetApiV1Ssoimage401,
  GetApiV1Ssoimage500,
  GetApiV1SsoimageQueryParams,
  GetApiV1SsoimageQueryResponse,
} from "../../types/SSOImageController/GetApiV1Ssoimage.ts";
import { SSOImageRepositoryResponsePaginatedResponseSchema } from "../SSOImageRepositoryResponsePaginatedResponseSchema.ts";

export const getApiV1SsoimageQueryParamsSchema = z.object({
  pageNumber: z.coerce.number().int().default(1),
  pageSize: z.coerce.number().int().default(10),
}) as unknown as ToZod<GetApiV1SsoimageQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1Ssoimage200Schema = z.lazy(
  () => SSOImageRepositoryResponsePaginatedResponseSchema,
) as unknown as ToZod<GetApiV1Ssoimage200>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const getApiV1Ssoimage400Schema =
  z.any() as unknown as ToZod<GetApiV1Ssoimage400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1Ssoimage401Schema =
  z.any() as unknown as ToZod<GetApiV1Ssoimage401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1Ssoimage500Schema =
  z.any() as unknown as ToZod<GetApiV1Ssoimage500>;

export const getApiV1SsoimageQueryResponseSchema = z.lazy(
  () => getApiV1Ssoimage200Schema,
) as unknown as ToZod<GetApiV1SsoimageQueryResponse>;
